/**
 * Pure: check if organization from GET /api/v3/organizations/{id} has all required fields.
 * Used to decide CreateOrganization step 1 (incomplete) vs step 2 (complete).
 * API shape: { id, name, industry, address: { street, city, state, zipCode }, ... }
 */

const hasAddress = (address) => {
  if (!address || typeof address !== 'object') return false;
  const { street, city, state, zipCode } = address;
  return [street, city, state, zipCode].every(
    (v) => v != null && String(v).trim() !== '',
  );
};

/**
 * @param {Object} org - Organization from API (normalized, no .data wrapper)
 * @returns {boolean} true if name, industry (or organizationType), and address are present and non-empty
 */
export function isOrganizationComplete(org) {
  if (!org || typeof org !== 'object') return false;
  const name = org.name ?? '';
  const industry = org.industry ?? org.organizationType ?? '';
  if (String(name).trim() === '' || String(industry).trim() === '') return false;
  return hasAddress(org.address);
}
